import { useEventCallback } from '@mui/material';
import {
  ContainerPopper,
  FakeDropdownBox,
  useDataGridContext,
  TitleMultipleSelector,
  type GroupedEntityTitleDto,
} from '@issuemanager/apps/client/components';
import { TitleColumnFilter } from '@issuemanager/client/features/issues';
import { useMemo } from 'react';
import type { IssueGridFilterModel } from './types';

export function IssueGridTitleFilter() {
  const context = useDataGridContext();
  const issueTitles: IssueGridFilterModel['title'] = context.filterModel.title;
  const actionTitles: IssueGridFilterModel['actionTitle'] =
    context.filterModel.actionTitle;

  const value: GroupedEntityTitleDto[] = (issueTitles ?? []).concat(
    actionTitles ?? [],
  );

  const handleChange = useEventCallback((value: GroupedEntityTitleDto[]) => {
    const title = value.filter(
      (v) => v.group === TitleColumnFilter.ISSUE_TITLE,
    );
    const actionTitle = value.filter(
      (v) => v.group === TitleColumnFilter.ACTION_TITLE,
    );
    context.setFilterModel((prevState) => ({
      ...prevState,
      title,
      actionTitle,
    }));
  });

  const memoizedValue = useMemo(
    () => (value.length > 0 ? value.map((c) => c.title).join(', ') : null),
    [value],
  );

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {memoizedValue}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <TitleMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
